import {
    ADD_USER,
    ADD_USER_SUCCESSFUL,
    ADD_USER_ERROR,
    GET_NEW_COGNITO_USER,
    GET_NEW_COGNITO_SUCCESSFUL,
    GET_NEW_COGNITO_USER_FAILED,
    UPDATE_COGNITO_USER,
    UPDATE_COGNITO_USER_SUCCESSFUL,
    UPDATE_COGNITO_USER_FAILED,
    DELETE_COGNITO_USER,
    DELETE_COGNITO_USER_SUCCESSFUL,
    DELETE_COGNITO_USER_FAILED,
  } from "./actionTypes";
  
  export const addUser = (user) => {
      console.log("Actions :: ", user)
      return {
          type: ADD_USER,
          payload: {user},
      }
  }
  
  export const addUserSuccessfull = (user) => {
      console.log("Is Success Called")
      return {
          type: ADD_USER_SUCCESSFUL,
          payload: {user}
      }
  }
  
  export const addUserError = (error) => {
      console.log("Is error called", error.response.data)
      return {
          type: ADD_USER_ERROR,
          payload: {error}
      }
  }
  
  export const getUser = (user) => {
      console.log("hello again");
      return {
          type: GET_NEW_COGNITO_USER,
          payload: { user }
      }
  }
  
  export const getUserSuccessful = (user) => {
      console.log("hello", user);
      return {
          type: GET_NEW_COGNITO_SUCCESSFUL,
          payload: { user },
      };
  };
  
  export const getUserFailed = (error) => {
      return {
          type: GET_NEW_COGNITO_USER_FAILED,
          payload: error,
      };
  };
  
  export const updateCognitoUser = (user) => {
    console.log("actions -> updateCognitoUser() called with", user);
    return {
      type: UPDATE_COGNITO_USER,
      payload: { user },
    };
  };
  
  export const updateCognitoUserSuccessful = (user) => {
    return {
      type: UPDATE_COGNITO_USER_SUCCESSFUL,
      payload: { user },
    };
  };
  
  export const updateCognitoUserFailed = (error) => {
    return {
      type: UPDATE_COGNITO_USER_FAILED,
      payload: { error },
    };
  };
  
  export const deleteCognitoUser = (username) => {
    console.log("actions -> deleteCognitoUser() called with", username);
    return {
      type: DELETE_COGNITO_USER,
      payload: { username },
    };
  };
  
  export const deleteCognitoUserSuccessful = (username) => {
    return {
      type: DELETE_COGNITO_USER_SUCCESSFUL,
      payload: { username },
    };
  };
  
  export const deleteCognitoUserFailed = (error) => {
    return {
      type: DELETE_COGNITO_USER_FAILED,
      payload: { error },
    };
  };
  